module.exports = __webpack_public_path__ + "media/assets/images/icons/studies/subject-icon-opened-325f32222a5a1d264a6d9a6e5e25abdb.svg";